module.exports = __webpack_public_path__ + "static/media/afm-warning-2x-en.32d2db7b.jpg";